<script lang="ts">
  import { receive, send } from '~/animations/crossfade.svelte';
  import Tile from '~/board/Tile.svelte';
  import DimensionsContext from '~/utils/DimensionsContext.svelte';

  type Props = {
    animate?: boolean;
    drawer?: boolean;
    gameOver?: boolean;
  };
  const props: Props = $props();

  const tiles = [
    { letter: 'G', color: 'blue' as const },
    { letter: 'R', color: 'blue' as const },
    { letter: 'A', color: 'blue' as const },
    { letter: 'M', color: 'blue' as const },
    { letter: 'J', color: 'green' as const },
    { letter: 'A', color: 'green' as const },
    { letter: 'M', color: 'green' as const },
  ];
</script>

<DimensionsContext {...{ width: 20, height: 20 }}>
  <div
    class="splash logo"
    class:animate={props.animate}
    class:drawer={props.drawer}
    class:gameOver={props.gameOver}
  >
    {#each tiles as tile, index (index)}
      <div
        class="tile-container {props.drawer ? 'drawer' : 'splash'}"
        out:send={{ key: String(index), index }}
        in:receive={{ key: String(index), index }}
      >
        <Tile
          highlighted={tile.color}
          tile={{ ...tile, id: String(index) }}
          size={props.drawer ? 'drawer' : 'splash'}
        />
      </div>
    {/each}
  </div>
</DimensionsContext>

<style lang="scss">
  @use '~/theme/include-media' as *;
  .splash:not(.drawer) {
    display: flex;
    width: fit-content;
  }
  .splash.gameOver {
    scale: 0.75;

    @include media('>=tablet') {
      scale: 0.625;
      margin: 0.25rem 0;
    }
  }
</style>
